<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page addorder-page" [dir]="isAr ? 'rtl' : 'ltr'">
  <div class="bb-page-shell">
    <div class="bb-page-header">
      <div class="bb-page-title-block">
                            <span class="bb-eyebrow">{{ 'add order' | transloco }}</span>
        <h2 class="bb-page-title">{{ "add order" | transloco }}</h2>
      </div>
    </div>

    <form class="bb-card bb-p-20" [formGroup]="data" (ngSubmit)="onSubmit()">
      <div class="bb-form-grid">
        @if(submitted && (data.invalid || hasNoSelectedItems())) {
        <div class="bb-form-alert bb-field-full" role="alert">
          {{ 'Review the order data before saving' | transloco }}
          @if(getMissingRequiredCount() > 0) {
          <span>
            ({{ getMissingRequiredCount() }} {{ 'required fields' | transloco }})
          </span>
          }
        </div>
        }

<ng-container *ngIf="hasBundles">
  <div class="bb-field bb-field-full bb-chip-select">
    <label class="bb-label bb-chip-label">{{ 'bundles' | transloco }}</label>

    <mat-form-field class="bb-chip-mat-field" appearance="outline">
      <mat-chip-grid #chipGridBundle class="bb-chip-grid-custom">
        <mat-chip-row
          *ngFor="let item of selectedBundlesDetails; trackBy: trackByBundle"
          (removed)="removeBundle(item.bundle.id)"
          class="bb-chip-item bb-chip-item-bundle"
        >
          {{ item.bundle.name_ar }}

          <button
            matChipRemove
            type="button"
            class="bb-chip-remove-btn"
            [attr.aria-label]="'remove bundle' | transloco"
            [attr.title]="'remove bundle' | transloco"
          >
            ×
          </button>
        </mat-chip-row>

        <input
          class="bb-chip-input"
          matInput
          placeholder="{{ 'bundles' | transloco }}"
          [value]="bundleSearchValue"
          (input)="onBundleSearchChange($event)"
          [matAutocomplete]="autoBundle"
          [matChipInputFor]="chipGridBundle"
        />
      </mat-chip-grid>
    </mat-form-field>
  </div>

  <mat-autocomplete
    #autoBundle="matAutocomplete"
    (optionSelected)="addBundle($event)"
    class="bb-chip-autocomplete-panel"
  >
    <mat-option *ngFor="let bundle of filteredBundles" [value]="bundle">
      {{ bundle.name_ar }} - {{ bundle.price }} {{ 'egpe' | transloco }}
    </mat-option>
  </mat-autocomplete>
</ng-container>

<div class="bb-field bb-field-full bb-chip-select" *ngIf="selectedValueFromStock">
  <label class="bb-label bb-chip-label">{{ "select product" | transloco }}</label>

  <mat-form-field class="bb-chip-mat-field" appearance="outline">
    <mat-chip-grid #chipGrid class="bb-chip-grid-custom">
      <mat-chip-row
        *ngFor="let item of selectedProductsDetails; trackBy: trackByProduct"
        (removed)="removeProduct(item.product.id)"
        class="bb-chip-item bb-chip-item-product"
      >
        {{ item.product.name_ar }}

        <button
          matChipRemove
          type="button"
          class="bb-chip-remove-btn"
          [attr.aria-label]="'remove product' | transloco"
          [attr.title]="'remove product' | transloco"
        >
          ×
        </button>
      </mat-chip-row>

      <input
        class="bb-chip-input"
        matInput
        placeholder="{{ 'select product'| transloco }}"
        [value]="searchValue"
        (input)="onSearchChange($event)"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipGrid"
      />
    </mat-chip-grid>
  </mat-form-field>

  @if(shouldShowItemsError()) {
  <div class="bb-field-error">
    {{ 'Select at least one product or bundle' | transloco }}
  </div>
  }
</div>

<mat-autocomplete
  #auto="matAutocomplete"
  (optionSelected)="addProduct($event)"
  class="bb-chip-autocomplete-panel"
>
  <mat-option *ngFor="let product of filteredProviders" [value]="product">
    {{ product.name_ar }} -
    @switch (accounttype) {
    @case ("2") { {{product.affiliationprice}} }
    @case ("3") { {{product.pricea}} }
    @case ("4") { {{product.priceb}} }
    @case ("5") { {{product.pricec}} }
    @default { {{product.price}} }
    }
    {{ 'egpe'| transloco }} - {{ product.weight }} - {{ 'quantity' | transloco }} {{ product.quantity }}
  </mat-option>
</mat-autocomplete>

        <div class="bb-field bb-field-full" *ngIf="clearClientBtn">
          <button (click)="clearClient()" class="bb-btn bb-btn-secondary" role="button">
            {{ 'clear client' | transloco }}
          </button>
        </div>

        <div class="bb-field">
          <label class="bb-label" for="client_name">{{ 'client name' | transloco }}</label>
          <input
            class="bb-input"
            type="text"
            id="client_name"
            formControlName="client_name"
            [placeholder]="'client name' | transloco"
            [(ngModel)]="client_name"
            [ngClass]="{
              'is-invalid': data.get('client_name')?.touched && data.get('client_name')?.invalid,
              'is-valid': data.get('client_name')?.touched && data.get('client_name')?.valid
            }"
          />
          @if(shouldShowError('client_name')) {
          <div class="bb-field-error">{{ getErrorMessage('client_name', ('client name' | transloco)) }}</div>
          }
        </div>

        <div class="bb-field">
          <label class="bb-label" for="phone_number">{{ 'Phone Number' | transloco }}</label>
          <input
            class="bb-input"
            type="text"
            id="phone_number"
            formControlName="phone_number"
            [placeholder]="'Phone Number' | transloco"
            [(ngModel)]="phone_number"
            [ngClass]="{
              'is-invalid': data.controls['phone_number'].touched && data.controls['phone_number'].errors,
              'is-valid': data.controls['phone_number'].touched && !data.controls['phone_number'].errors,
              'is-touched': data.controls['phone_number'].untouched && !data.controls['phone_number'].errors,
            }"
          />
          @if(shouldShowError('phone_number')) {
          <div class="bb-field-error">{{ getErrorMessage('phone_number', ('Phone Number' | transloco)) }}</div>
          }
        </div>

        <div class="bb-field bb-field-full">
          <label class="bb-label" for="another_phone">{{ 'Another Phone Number' | transloco }}</label>
          <input
            class="bb-input"
            type="text"
            id="another_phone"
            formControlName="another_phone"
            [placeholder]="'Another Phone Number' | transloco"
            [(ngModel)]="another_phone"
            [ngClass]="{
              'is-invalid': data.controls['another_phone'].touched && data.controls['another_phone'].errors,
              'is-valid': data.controls['another_phone'].touched && !data.controls['another_phone'].errors,
              'is-touched': data.controls['another_phone'].untouched && !data.controls['another_phone'].errors,
            }"
          />
          @if(shouldShowError('another_phone')) {
          <div class="bb-field-error">{{ getErrorMessage('another_phone', ('Another Phone Number' | transloco)) }}</div>
          }
        </div>

        <div class="bb-field">
          <label class="bb-label" for="building_number">{{ 'Building number' | transloco }}</label>
          <input
            class="bb-input"
            id="building_number"
            formControlName="building_number"
            [placeholder]="'Building number' | transloco"
            [ngClass]="{
              'is-invalid': data.get('building_number')?.touched && data.get('building_number')?.invalid,
              'is-valid': data.get('building_number')?.touched && data.get('building_number')?.valid
            }"
          />
          @if(shouldShowError('building_number')) {
          <div class="bb-field-error">{{ getErrorMessage('building_number', ('Building number' | transloco)) }}</div>
          }
        </div>

        <div class="bb-field">
          <label class="bb-label" for="street">{{ 'Street' | transloco }}</label>
          <input
            class="bb-input"
            id="street"
            formControlName="street"
            [placeholder]="'Street' | transloco"
            [ngClass]="{
              'is-invalid': data.get('street')?.touched && data.get('street')?.invalid,
              'is-valid': data.get('street')?.touched && data.get('street')?.valid
            }"
          />
          @if(shouldShowError('street')) {
          <div class="bb-field-error">{{ getErrorMessage('street', ('Street' | transloco)) }}</div>
          }
        </div>

        <div class="bb-field">
          <label class="bb-label" for="landmark">{{ 'Landmark' | transloco }}</label>
          <input
            class="bb-input"
            id="landmark"
            formControlName="landmark"
            [placeholder]="'Landmark' | transloco"
            [ngClass]="{
              'is-invalid': data.get('landmark')?.touched && data.get('landmark')?.invalid,
              'is-valid': data.get('landmark')?.touched && data.get('landmark')?.valid
            }"
          />
          @if(shouldShowError('landmark')) {
          <div class="bb-field-error">{{ getErrorMessage('landmark', ('Landmark' | transloco)) }}</div>
          }
        </div>

        <div class="bb-field">
          <label class="bb-label" for="floor">{{ 'Floor' | transloco }}</label>
          <input
            class="bb-input"
            id="floor"
            formControlName="floor"
            [placeholder]="'Floor' | transloco"
            [ngClass]="{
              'is-invalid': data.get('floor')?.touched && data.get('floor')?.invalid,
              'is-valid': data.get('floor')?.touched && data.get('floor')?.valid
            }"
          />
          @if(shouldShowError('floor')) {
          <div class="bb-field-error">{{ getErrorMessage('floor', ('Floor' | transloco)) }}</div>
          }
        </div>

        <div class="bb-field bb-field-full">
          <label class="bb-label" for="home">{{ 'Apartment' | transloco }}</label>
          <input
            class="bb-input"
            id="home"
            formControlName="home"
            [placeholder]="'Apartment' | transloco"
            [ngClass]="{
              'is-invalid': data.get('home')?.touched && data.get('home')?.invalid,
              'is-valid': data.get('home')?.touched && data.get('home')?.valid
            }"
          />
          @if(shouldShowError('home')) {
          <div class="bb-field-error">{{ getErrorMessage('home', ('Apartment' | transloco)) }}</div>
          }
        </div>

        <div class="bb-field">
          <label class="bb-label">{{ "Select Governorate" | transloco }}</label>
          <div class="bb-select-wrap">
            <select
              class="bb-select"
              formControlName="government_id"
              [(ngModel)]="government_id"
              (change)="loadCities($event)"
              [ngClass]="{
                'is-invalid': data.controls['government_id'].touched && data.controls['government_id'].errors,
                'is-valid': data.controls['government_id'].touched && !data.controls['government_id'].errors,
                'is-touched': data.controls['government_id'].untouched && !data.controls['government_id'].errors,
              }"
            >
              <option value="">{{ "Select Governorate" | transloco }}</option>
              <option *ngFor="let gov of governorates" [value]="gov.id">
                {{ isAr ? gov.governorate_name_ar : gov.governorate_name_en }}
              </option>
            </select>
          </div>
          @if(shouldShowError('government_id')) {
          <div class="bb-field-error">{{ getErrorMessage('government_id', ('Select Governorate' | transloco)) }}</div>
          }
        </div>

        <div class="bb-field">
          <label class="bb-label">{{ "Select area" | transloco }}</label>
          <div class="bb-select-wrap">
            <select
              class="bb-select"
              formControlName="city_id"
              [(ngModel)]="city_id"
              [ngClass]="{
                'is-invalid': data.controls['city_id'].touched && data.controls['city_id'].errors,
                'is-valid': data.controls['city_id'].touched && !data.controls['city_id'].errors,
                'is-touched': data.controls['city_id'].untouched && !data.controls['city_id'].errors,
              }"
            >
              <option value="">{{ "Select area" | transloco }}</option>
              <option *ngFor="let city of cities" [value]="city.id">
                {{ isAr ? city.city_name_ar : city.city_name_en }}
              </option>
            </select>
          </div>
          @if(shouldShowError('city_id')) {
          <div class="bb-field-error">{{ getErrorMessage('city_id', ('Select area' | transloco)) }}</div>
          }
        </div>

        <div class="bb-field">
          <label class="bb-label" for="delivery_fees">{{ 'delivery fees' | transloco }}</label>
          <input
            class="bb-input"
            type="number"
            id="delivery_fees"
            formControlName="delivery_fees"
            [placeholder]="'delivery fees' | transloco"
            [(ngModel)]="delivery_fees"
            [ngClass]="{
              'is-invalid': data.controls['delivery_fees'].touched && data.controls['delivery_fees'].errors,
              'is-valid': data.controls['delivery_fees'].touched && !data.controls['delivery_fees'].errors,
              'is-touched': data.controls['delivery_fees'].untouched && !data.controls['delivery_fees'].errors,
            }"
          />
          @if(shouldShowError('delivery_fees')) {
          <div class="bb-field-error">{{ getErrorMessage('delivery_fees', ('delivery fees' | transloco)) }}</div>
          }
        </div>

        <div class="bb-field">
          <label class="bb-label" for="note">{{ 'note' | transloco }}</label>
          <input
            class="bb-input"
            type="text"
            id="note"
            formControlName="note"
            [placeholder]="'note' | transloco"
            [(ngModel)]="note"
            [ngClass]="{
              'is-invalid': data.controls['note'].touched && data.controls['note'].errors,
              'is-valid': data.controls['note'].touched && !data.controls['note'].errors,
              'is-touched': data.controls['note'].untouched && !data.controls['note'].errors,
            }"
          />
        </div>

        <div class="bb-field bb-field-full" *ngIf="showAllUsers">
          <label class="bb-label" for="createby">{{ 'create this order by' | transloco }}</label>
          <div class="bb-select-wrap">
            <select
              id="createby"
              class="bb-select"
              (ngModelChange)="onitemchange($event)"
              formControlName="createby"
              [ngClass]="{
                'is-invalid': data.get('createby')?.touched && data.get('createby')?.invalid,
                'is-valid': data.get('createby')?.touched && data.get('createby')?.valid
              }"
            >
              <option value="" disabled selected>{{ 'select' | transloco }}</option>
              <option *ngFor="let user of users" [value]="user.id + 'type' + user.type">
                {{ user.last_name }}
              </option>
            </select>
          </div>
          @if(shouldShowError('createby')) {
          <div class="bb-field-error">{{ getErrorMessage('createby', ('create this order by' | transloco)) }}</div>
          }
        </div>

        <ng-container *ngIf="isUpdate; else normalMode">
          <div class="bb-field bb-field-full">
            <label class="bb-label">{{ 'Selected Items' | transloco }}</label>

            <div *ngFor="let item of selectedProductsDetails" class="bb-card bb-p-16 bb-mb-12">
              <div class="bb-text-stack">
                <p class="bb-m-0 bb-font-bold"><strong>{{ 'product_label' | transloco }}</strong> {{ item.product.name_ar }}</p>

                <label class="bb-label">
                  <strong>{{ 'quantity_label' | transloco }}</strong>
                  <input
                    type="number"
                    class="bb-input bb-mt-8"
                    [(ngModel)]="item.quantity"
                    min="1"
                    name="quantity_{{ item.product.id }}"
                  />
                </label>

                <p class="bb-m-0 bb-price"><strong>{{ 'price_label' | transloco }}</strong> {{ item.price }} {{ 'egp' | transloco }}</p>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-template #normalMode>
          <div class="bb-field bb-field-full" *ngIf="selectedBundlesDetails.length > 0">
            <label class="bb-label">{{ 'bundles' | transloco }}</label>

            <div class="addorder-product-list" *ngIf="isMobile; else bundlesTable">
              <article
                class="addorder-product-card"
                *ngFor="let bundle of selectedBundlesDetails"
              >
                <div class="addorder-product-head">
                  <span>
                    {{ 'bundles' | transloco }}
                  </span>

                  <strong>
                    {{ bundle.bundle.name_ar }}
                  </strong>
                </div>

                <div class="addorder-product-fields">
                  <label class="bb-label">
                    {{ 'quantity' | transloco }}

                    <input
                      type="number"
                      min="1"
                      class="bb-input"
                      [(ngModel)]="bundle.quantity"
                      [ngModelOptions]="{ standalone: true }"
                    />
                  </label>

                  <label class="bb-label">
                    {{ 'price' | transloco }}

                    <input
                      type="number"
                      min="0"
                      class="bb-input"
                      [(ngModel)]="bundle.price"
                      [ngModelOptions]="{ standalone: true }"
                    />
                  </label>
                </div>
              </article>
            </div>

            <ng-template #bundlesTable>
            <div class="bb-table-scroll">
              <table class="bb-table">
                <thead>
                  <tr>
                    <th class="mat-header-cell-custom">{{ 'bundles' | transloco }}</th>
                    <th class="mat-header-cell-custom">{{ 'quantity' | transloco }}</th>
                    <th class="mat-header-cell-custom">{{ 'price' | transloco }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let bundle of selectedBundlesDetails">
                    <td class="mat-cell-custom bb-font-bold">{{ bundle.bundle.name_ar }}</td>
                    <td class="mat-cell-custom">
                      <input
                        type="number"
                        min="1"
                        class="bb-input"
                        [placeholder]="'quantity' | transloco"
                        [(ngModel)]="bundle.quantity"
                        [ngModelOptions]="{ standalone: true }"
                      />
                    </td>
                    <td class="mat-cell-custom">
                      <input
                        type="number"
                        min="0"
                        class="bb-input"
                        [placeholder]="'price' | transloco"
                        [(ngModel)]="bundle.price"
                        [ngModelOptions]="{ standalone: true }"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            </ng-template>
          </div>

          <div class="bb-field bb-field-full" *ngIf="selectedProductsDetails.length > 0">
            <label class="bb-label">{{ 'Product' | transloco }}</label>

            <div class="addorder-product-list" *ngIf="isMobile; else productsTable">
              <article
                class="addorder-product-card"
                *ngFor="let item of selectedProductsDetails"
              >
                <div class="addorder-product-head">
                  <span>
                    {{ 'Product' | transloco }}
                  </span>

                  <strong>
                    {{ item.product.name_ar }}
                  </strong>
                </div>

                <div class="addorder-product-fields">
                  <label class="bb-label">
                    {{ 'quantity' | transloco }}

                    <input
                      type="number"
                      min="1"
                      class="bb-input"
                      [(ngModel)]="item.quantity"
                      [ngModelOptions]="{ standalone: true }"
                    />
                  </label>

                  <label class="bb-label" *ngIf="!warehouseIsStore">
                    {{ 'price' | transloco }}

                    <input
                      type="number"
                      min="0"
                      class="bb-input"
                      [(ngModel)]="item.price"
                      [ngModelOptions]="{ standalone: true }"
                    />
                  </label>

                  <label class="bb-label" *ngIf="warehouseIsStore">
                    {{ 'Bonus' | transloco }}

                    <input
                      type="number"
                      min="0"
                      class="bb-input"
                      [(ngModel)]="item.bounes"
                      [ngModelOptions]="{ standalone: true }"
                    />
                  </label>
                </div>
              </article>
            </div>

            <ng-template #productsTable>
            <div class="bb-table-scroll">
              <table class="bb-table">
                <thead>
                  <tr>
                    <th class="mat-header-cell-custom">{{ 'Product' | transloco }}</th>
                    <th class="mat-header-cell-custom">{{ 'quantity' | transloco }}</th>
                    <th class="mat-header-cell-custom">
                      <span *ngIf="warehouseIsStore">{{ 'Bonus' | transloco }}</span>
                      <span *ngIf="!warehouseIsStore">{{ 'price' | transloco }}</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of selectedProductsDetails">
                    <td class="mat-cell-custom bb-font-bold">{{ item.product.name_ar }}</td>
                    <td class="mat-cell-custom">
                      <input
                        type="number"
                        min="1"
                        class="bb-input"
                        [(ngModel)]="item.quantity"
                        [ngModelOptions]="{ standalone: true }"
                      />
                    </td>
                    <td class="mat-cell-custom">
                      <input
                        type="number"
                        min="0"
                        class="bb-input"
                        [(ngModel)]="item.price"
                        [ngModelOptions]="{ standalone: true }"
                        *ngIf="!warehouseIsStore"
                      />
                      <input
                        type="number"
                        min="0"
                        class="bb-input"
                        [(ngModel)]="item.bounes"
                        [ngModelOptions]="{ standalone: true }"
                        *ngIf="warehouseIsStore"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            </ng-template>
          </div>
        </ng-template>

        <div #formElement></div>

        <div class="bb-form-alert bb-field-full" *ngIf="backendErrors.length > 0">
          <strong>{{ 'Please check the following errors:' | transloco }}</strong>

          <ul>
            <li *ngFor="let error of backendErrors">
              {{ error }}
            </li>
          </ul>
        </div>

        <div class="bb-field bb-field-full bb-flex bb-justify-start bb-mt-16">
          <button
            *ngIf="isUpdate; else submitBtn"
            type="button"
            (click)="updateOrder()"
            class="bb-btn bb-btn-primary "
          >
            {{ "update" | transloco }}
          </button>
          <!-- Submit -->
   
          <ng-template #submitBtn>
                   <div class="bb-field bb-field-full bb-mt-16">
            <button class="bb-btn bb-btn-primary bb-w-100"       [class.is-disabled]="data.invalid || hasNoSelectedItems()">
              {{ 'Submit' | transloco }}
            </button>
          </div>

          </ng-template>
        </div>
      </div>
    </form>
  </div>
</section>
